import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import Wallpaper from '../../../domain/entities/Wallpaper';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexWallpapersSuccess: {
      const result = action.payload as PaginatedResult<Wallpaper>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
